module.exports = __webpack_public_path__ + "img/download_app_qrcode.99c13ce0.png";